import { Skeleton } from '@/components/ui/skeleton'

export function KnowledgeGraphViewSkeleton() {
  return (
    <div
      className="flex h-full min-h-0 flex-col gap-4"
      aria-busy="true"
      aria-label="Loading knowledge graph"
    >
      <div className="flex flex-col gap-2">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-72" />
        <div className="mt-1 flex flex-wrap gap-2">
          <Skeleton className="h-7 w-24 rounded-full" />
          <Skeleton className="h-7 w-28 rounded-full" />
          <Skeleton className="h-7 w-20 rounded-full" />
        </div>
        <Skeleton className="h-8 w-full max-w-sm" />
      </div>
      <Skeleton className="min-h-[24rem] flex-1 rounded-md" />
    </div>
  )
}
